class Nav {

  /**
   * Add nav functionalities
   *
   * @param {HTMLElement} el Element to wrap.
   */
  constructor(el) {
    this.element = el;

    el.addEventListener('toggle', (e) => {
      if (el.hasAttribute('open')) {
        document.addEventListener('click', this.toggleMenu);
      } else {
        document.removeEventListener('click', this.toggleMenu)
      }
    })
  }

  toggleMenu = (e) => {
    document.addEventListener('click', (e) => {
      if (!e.target.classList.contains('js-nav-item') && this.element.hasAttribute('open')) {
        this.element.removeAttribute('open')
      }
    });
  }

}

export default Nav;
